import api from "../_api";

const show = async (context, employerNumber) => {
  const result = await api.show(employerNumber);
  context.commit("SET_PROVIDER", result);
};

export default {
  show
};
